import { createFileRoute } from '@tanstack/react-router';

import StoreSettingsPage from '@/components/store/settings/Page';

export const Route = createFileRoute('/store/settings')({
	component: StoreSettingsPage,
});
